export default "__VITE_ASSET__8f61faea__"